<template>
    <div class="grid">
        <div class="col-12">
            <div class="p-fluid">
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Payroll</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.payroll_fee" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Administrasi</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.administration_fee" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Training (Diklat)</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.training_fee" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Absent Days</label>
                    <div class="col-12 md:col-1">
                        <InputText type="number" min="0" max="30" id="salary" mode="decimal" locale="id-ID" v-model="form.days_absent" @input="calculateAbsentDeduction(form.days_absent)"/>
                    </div>
                    <div class="col-12 md:col-3">
                        <Dropdown v-model="form.total_work_days" :options="workDays" placeholder="Select Work Days" @change="calculateAbsentDeduction(form.days_absent)"/>
                        Hari Kerja
                    </div>
                    <div class="col-12 md:col-4">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.absent_deduction" />
                        Totalnya
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">Loan</label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.loan_deduction" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">
                        pph21
                        <div class="ml-2">
                            <Checkbox id="isPPH21" v-model="form.is_pph21" :binary="true" name="isPPH21" @change="setPPH21Value" />
                        </div>
                    </label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.pph21_deduction" :disabled="!form.is_pph21" />
                    </div>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">
                        BPJS JHT
                        <div class="ml-2">
                            <Checkbox id="isPPN" v-model="form.is_jht" :binary="true" name="Passed" @change="setBpjsJhtValue" />
                        </div>
                    </label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.bpjs_jht_deduction" :disabled="!form.is_jht" />
                    </div>
                    <Dialog header="Rumus BPJS JHT" v-model:visible="displayBpjsJht" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true">
                        <p class="line-height-3 m-0">
                            Gaji Pokok * 2 / 100
                        </p>
                        <template #footer>
                            <Button label="Ok" @click="displayBpjsJht = false" icon="pi pi-check" class="p-button-outlined"/>
                        </template>
                    </Dialog>
                    <Button label="Rumus" icon="pi pi-external-link" style="width: auto" @click="displayBpjsJht = true"/>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">
                        BPJS JP
                        <div class="ml-2">
                            <Checkbox id="isPPN" v-model="form.is_jp" :binary="true" name="Passed" @change="setBpjsJpValue" />
                        </div>
                    </label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.bpjs_jp_deduction" :disabled="!form.is_jp" />
                    </div>
                    <Dialog header="Rumus BPJS JP" v-model:visible="displayBpjsJp" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true">
                        <p class="line-height-3 m-0">
                            Gaji Pokok * 1 / 100
                        </p>
                        <template #footer>
                            <Button label="Ok" @click="displayBpjsJp = false" icon="pi pi-check" class="p-button-outlined"/>
                        </template>
                    </Dialog>
                    <Button label="Rumus" icon="pi pi-external-link" style="width: auto" @click="displayBpjsJp = true"/>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">
                        BPJS KESEHATAN
                        <div class="ml-2">
                            <Checkbox id="isPPN" v-model="form.is_bpjs_kesehatan" :binary="true" name="Passed" @change="setBpjsKesehatanValue" />
                        </div>
                    </label>
                    <div class="col-12 md:col-5">
                        <InputNumber id="salary" mode="decimal" locale="id-ID" v-model="form.bpjs_kesehatan_deduction" :disabled="!form.is_bpjs_kesehatan"/>
                    </div>
                    <Dialog header="Rumus BPJS Kesehatan" v-model:visible="displayBpjsJk" :breakpoints="{'960px': '75vw'}" :style="{width: '30vw'}" :modal="true">
                        <p class="line-height-3 m-0">
                            Gaji Pokok * 1 / 100
                        </p>
                        <template #footer>
                            <Button label="Ok" @click="displayBpjsJk = false" icon="pi pi-check" class="p-button-outlined"/>
                        </template>
                    </Dialog>
                    <Button label="Rumus" icon="pi pi-external-link"  style="width: auto" @click="displayBpjsJk = true"/>
                </div>
                <div class="field grid">
                    <label for="name4" class="col-12 mb-2 md:col-3 md:mb-0">
                        Total Deduction
                    </label>
                    <div class="col-12 md:col-5">
                        {{ totalDeduction }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Button from 'primevue/button';
import Checkbox from 'primevue/checkbox';
import Calendar from 'primevue/calendar';
import Dropdown from 'primevue/dropdown';
import InputText from 'primevue/inputtext';
import InputNumber from 'primevue/inputnumber';
import Dialog from 'primevue/dialog';

export default{
    components:{
        Button, Calendar, Dropdown, InputText, InputNumber, Checkbox, Dialog,
    },
    props: ['model','additionalIncome'],
    computed: {
        totalDeduction(){
            return this.calculateDeduction();
        },
    },
    data(){
        return{
            form: this.$page.props.payroll ?? {
                total_work_days: 20,
            },
            umr: 4613000,
            workDays: [20,25,30],
            displayBpjsJk: false,
            displayBpjsJht: false,
            displayBpjsJp: false,
            // Peraturan Direktur Jenderal Pajak Nomor PER-16/PJ/2016 tentang tata cara pemotongan PPh Pasal 21.
            terAData: [
                { min: 0,        max: 4500000,      range: '≤ 4.500.000',            ter: 0.0000 },   // Di bawah PTKP, bebas pajak
                { min: 4500001,  max: 5000000,      range: '4.500.001 – 5.000.000',  ter: 0.0050 },   // Tarif rendah mulai dikenakan
                { min: 5000001,  max: 6000000,      range: '5.000.001 – 6.000.000',  ter: 0.0100 },
                { min: 6000001,  max: 7000000,      range: '6.000.001 – 7.000.000',  ter: 0.0150 },
                { min: 7000001,  max: 8000000,      range: '7.000.001 – 8.000.000',  ter: 0.0200 },
                { min: 8000001,  max: 9000000,      range: '8.000.001 – 9.000.000',  ter: 0.0300 },
                { min: 9000001,  max: 10000000,     range: '9.000.001 – 10.000.000', ter: 0.0400 },
                { min: 10000001, max: 12000000,     range: '10.000.001 – 12.000.000',ter: 0.0550 },
                { min: 12000001, max: 14000000,     range: '12.000.001 – 14.000.000',ter: 0.0700 },
                { min: 14000001, max: 16000000,     range: '14.000.001 – 16.000.000',ter: 0.0850 },
                { min: 16000001, max: 18000000,     range: '16.000.001 – 18.000.000',ter: 0.1000 },
                { min: 18000001, max: 20000000,     range: '18.000.001 – 20.000.000',ter: 0.1150 },
                { min: 20000001, max: 25000000,     range: '20.000.001 – 25.000.000',ter: 0.1300 },
                { min: 25000001, max: 30000000,     range: '25.000.001 – 30.000.000',ter: 0.1400 },
                { min: 30000001, max: 35000000,     range: '30.000.001 – 35.000.000',ter: 0.1500 },
                { min: 35000001, max: 40000000,     range: '35.000.001 – 40.000.000',ter: 0.1600 },
                { min: 40000001, max: 50000000,     range: '40.000.001 – 50.000.000',ter: 0.1700 },
                { min: 50000001, max: 60000000,     range: '50.000.001 – 60.000.000',ter: 0.1800 },
                { min: 60000001, max: 70000000,     range: '60.000.001 – 70.000.000',ter: 0.1900 },
                { min: 70000001, max: 80000000,     range: '70.000.001 – 80.000.000',ter: 0.2000 },
                { min: 80000001, max: Infinity,     range: '> 80.000.000',          ter: 0.2100 },
            ],
            // Peraturan Direktur Jenderal Pajak Nomor PER-16/PJ/2016 tentang tata cara pemotongan PPh Pasal 21.
            terBData: [
                { min: 0,        max: 6600000,      range: '≤ 6.600.000',           ter: 0.0000 },   // Bebas pajak hingga 6,6 juta (PTKP K/0)
                { min: 6600001,  max: 7000000,      range: '6.600.001 – 7.000.000', ter: 0.0050 },
                { min: 7000001,  max: 8000000,      range: '7.000.001 – 8.000.000', ter: 0.0100 },
                { min: 8000001,  max: 9000000,      range: '8.000.001 – 9.000.000', ter: 0.0150 },
                { min: 9000001,  max: 10000000,     range: '9.000.001 – 10.000.000',ter: 0.0250 },
                { min: 10000001, max: 12000000,     range: '10.000.001 – 12.000.000',ter: 0.0350 },
                { min: 12000001, max: 14000000,     range: '12.000.001 – 14.000.000',ter: 0.0450 },
                { min: 14000001, max: 16000000,     range: '14.000.001 – 16.000.000',ter: 0.0550 },
                { min: 16000001, max: 18000000,     range: '16.000.001 – 18.000.000',ter: 0.0650 },
                { min: 18000001, max: 20000000,     range: '18.000.001 – 20.000.000',ter: 0.0750 },
                { min: 20000001, max: 25000000,     range: '20.000.001 – 25.000.000',ter: 0.0850 },
                { min: 25000001, max: 30000000,     range: '25.000.001 – 30.000.000',ter: 0.0950 },
                { min: 30000001, max: 35000000,     range: '30.000.001 – 35.000.000',ter: 0.1050 },
                { min: 35000001, max: 40000000,     range: '35.000.001 – 40.000.000',ter: 0.1150 },
                { min: 40000001, max: 50000000,     range: '40.000.001 – 50.000.000',ter: 0.1250 },
                { min: 50000001, max: 60000000,     range: '50.000.001 – 60.000.000',ter: 0.1350 },
                { min: 60000001, max: 70000000,     range: '60.000.001 – 70.000.000',ter: 0.1450 },
                { min: 70000001, max: 80000000,     range: '70.000.001 – 80.000.000',ter: 0.1550 },
                { min: 80000001, max: Infinity,     range: '> 80.000.000',          ter: 0.1650 },
            ],
            // Peraturan Direktur Jenderal Pajak Nomor PER-16/PJ/2016 tentang tata cara pemotongan PPh Pasal 21.
            terCData: [
                { min: 0, max: 6600000, range: '≤ 6.600.000', ter: 0.0000 },
                { min: 6600001, max: 6950000, range: '6.600.001 – 6.950.000', ter: 0.0025 },
                { min: 6950001, max: 7350000, range: '6.950.001 – 7.350.000', ter: 0.0050 },
                { min: 7350001, max: 7800000, range: '7.350.001 – 7.800.000', ter: 0.0075 },
                { min: 7800001, max: 8850000, range: '7.800.001 – 8.850.000', ter: 0.0100 },
                { min: 8850001, max: 9800000, range: '8.850.001 – 9.800.000', ter: 0.0125 },
                { min: 9800001, max: 10850000, range: '9.800.001 – 10.850.000', ter: 0.0150 },
                { min: 10850001, max: 11800000, range: '10.850.001 – 11.800.000', ter: 0.0175 },
                { min: 11800001, max: 13250000, range: '11.800.001 – 13.250.000', ter: 0.0200 },
                { min: 13250001, max: 14700000, range: '13.250.001 – 14.700.000', ter: 0.0225 },
                { min: 14700001, max: 16150000, range: '14.700.001 – 16.150.000', ter: 0.0250 },
                { min: 16150001, max: 17600000, range: '16.150.001 – 17.600.000', ter: 0.0275 },
                { min: 17600001, max: 19050000, range: '17.600.001 – 19.050.000', ter: 0.0300 },
                { min: 19050001, max: 21500000, range: '19.050.001 – 21.500.000', ter: 0.0325 },
                { min: 21500001, max: 23900000, range: '21.500.001 – 23.900.000', ter: 0.0350 },
                { min: 23900001, max: 26350000, range: '23.900.001 – 26.350.000', ter: 0.0375 },
                { min: 26350001, max: 28800000, range: '26.350.001 – 28.800.000', ter: 0.0400 },
                { min: 28800001, max: 31200000, range: '28.800.001 – 31.200.000', ter: 0.0425 },
                { min: 31200001, max: 33650000, range: '31.200.001 – 33.650.000', ter: 0.0450 },
                { min: 33650001, max: 36100000, range: '33.650.001 – 36.100.000', ter: 0.0475 },
                { min: 36100001, max: 38550000, range: '36.100.001 – 38.550.000', ter: 0.0500 },
                { min: 38550001, max: 41000000, range: '38.550.001 – 41.000.000', ter: 0.0525 },
                { min: 41000001, max: 43450000, range: '41.000.001 – 43.450.000', ter: 0.0550 },
                { min: 43450001, max: 45900000, range: '43.450.001 – 45.900.000', ter: 0.0575 },
                { min: 45900001, max: 48350000, range: '45.900.001 – 48.350.000', ter: 0.0600 },
                { min: 48350001, max: 50800000, range: '48.350.001 – 50.800.000', ter: 0.0625 },
                { min: 50800001, max: 53250000, range: '50.800.001 – 53.250.000', ter: 0.0650 },
                { min: 53250001, max: 55700000, range: '53.250.001 – 55.700.000', ter: 0.0675 },
                { min: 55700001, max: 58150000, range: '55.700.001 – 58.150.000', ter: 0.0700 },
                { min: 58150001, max: 60600000, range: '58.150.001 – 60.600.000', ter: 0.0725 },
                { min: 60600001, max: 63050000, range: '60.600.001 – 63.050.000', ter: 0.0750 },
                { min: 63050001, max: 65500000, range: '63.050.001 – 65.500.000', ter: 0.0775 },
                { min: 65500001, max: 67950000, range: '65.500.001 – 67.950.000', ter: 0.0800 },
                { min: 67950001, max: 70400000, range: '67.950.001 – 70.400.000', ter: 0.0825 },
                { min: 70400001, max: 72850000, range: '70.400.001 – 72.850.000', ter: 0.0850 },
                { min: 72850001, max: 75300000, range: '72.850.001 – 75.300.000', ter: 0.0875 },
                { min: 75300001, max: 77750000, range: '75.300.001 – 77.750.000', ter: 0.0900 },
                { min: 77750001, max: 80200000, range: '77.750.001 – 80.200.000', ter: 0.0925 },
                { min: 80200001, max: 82650000, range: '80.200.001 – 82.650.000', ter: 0.0950 },
                { min: 82650001, max: 85100000, range: '82.650.001 – 85.100.000', ter: 0.0975 },
                { min: 85100001, max: Infinity, range: '> 85.100.000', ter: 0.1000 }
            ]
        }
    },
    mounted(){
        this.setBpjsJhtValue();
        this.setBpjsJpValue();
        this.setBpjsKesehatanValue();
    },
    methods: {
        calculateDeduction(){
            let deduction = this.form;
            let netDeduction = 0;

            deduction.payroll_fee = !isNaN(parseInt(deduction.payroll_fee)) ? parseInt(deduction.payroll_fee) : 0;
            deduction.administration_fee = !isNaN(parseInt(deduction.administration_fee)) ? parseInt(deduction.administration_fee) : 0;
            deduction.training_fee = !isNaN(parseInt(deduction.training_fee)) ? parseInt(deduction.training_fee) : 0;
            deduction.absent_deduction = !isNaN(parseInt(deduction.absent_deduction)) ? parseInt(deduction.absent_deduction) : 0;
            deduction.loan_deduction = !isNaN(parseInt(deduction.loan_deduction)) ?  parseInt(deduction.loan_deduction) : 0;
            deduction.pph21_deduction = !isNaN(parseInt(deduction.pph21_deduction)) ? parseInt(deduction.pph21_deduction) : 0;
            deduction.bpjs_kesehatan_deduction = !isNaN(parseInt(deduction.bpjs_kesehatan_deduction)) ? parseInt(deduction.bpjs_kesehatan_deduction) : 0;
            deduction.bpjs_jht_deduction = !isNaN(parseInt(deduction.bpjs_jht_deduction)) ? parseInt(deduction.bpjs_jht_deduction) : 0;
            deduction.bpjs_jp_deduction = !isNaN(parseInt(deduction.bpjs_jp_deduction)) ? parseInt(deduction.bpjs_jp_deduction) : 0;

            netDeduction = deduction.payroll_fee + deduction.administration_fee + deduction.training_fee +
                        deduction.absent_deduction + deduction.loan_deduction + deduction.pph21_deduction +
                        deduction.bpjs_kesehatan_deduction + deduction.bpjs_jht_deduction + deduction.bpjs_jp_deduction;

            return netDeduction.toLocaleString('id-ID');
        },

        setPPH21Value(){
            let additionalIncome = Object.values(this.additionalIncome).reduce((a, b) => a + b, 0);
            let incomeAll = this.model.salary.salary + additionalIncome - this.form.bpjs_jht_deduction - this.form.bpjs_jp_deduction - this.form.absent_deduction ;

            let marriageStatus = this.model.marital_status;
            let liability = Object.keys(this.model.families).length;

            if(this.form.is_pph21){
                // Peraturan Direktur Jenderal Pajak Nomor PER-16/PJ/2016 tentang tata cara pemotongan PPh Pasal 21.
                if((marriageStatus == 'married' || marriageStatus == 'single' ) && liability <= 1){
                    let found = this.terAData.find(item => incomeAll >= item.min && incomeAll <= item.max);
                    this.form.pph21_deduction = incomeAll * found.ter;
                }

                if((marriageStatus == 'married' || marriageStatus == 'single' ) && (liability >= 2 && liability <= 3)){
                    let found = this.terBData.find(item => incomeAll >= item.min && incomeAll <= item.max);
                    this.form.pph21_deduction = incomeAll * found.ter;
                }

                 if(marriageStatus == 'married' && liability >= 3 ){
                    let found = this.terCData.find(item => incomeAll >= item.min && incomeAll <= item.max);
                    this.form.pph21_deduction = incomeAll * found.ter;
                }
            }else{
                this.form.pph21_deduction = 0; // update the value to 0 when unchecked
            }
        },
        setBpjsJhtValue(){
            if(this.form.is_jht){
                let baseSalary =  this.model.salary.salary < this.umr ? this.umr : this.model.salary.salary;
                this.form.bpjs_jht_deduction = baseSalary * 2 / 100;
            }else{
                this.form.bpjs_jht_deduction = 0;
            }
        },
        setBpjsJpValue(){
            if(this.form.is_jp){
                let baseSalary =  this.model.salary.salary < this.umr ? this.umr : this.model.salary.salary;
                this.form.bpjs_jp_deduction = baseSalary * 1 / 100;
            }else{
                this.form.bpjs_jp_deduction = 0;
            }
        },
        setBpjsKesehatanValue(){
            if(this.form.is_bpjs_kesehatan){
                let baseSalary =  this.model.salary.salary < this.umr ? this.umr : this.model.salary.salary;
                this.form.bpjs_kesehatan_deduction = baseSalary * 1 / 100;
            }else{
                this.form.bpjs_kesehatan_deduction = 0;
            }
        },

        calculateAbsentDeduction(value){
            let baseSalary = this.model.salary.salary;
            this.form.absent_deduction = baseSalary / this.form.total_work_days * value;
        },
    },
}
</script>
